var _defs, _circle, _line, _line2, _line3, _line4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew286({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 3.06
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 14,
    y1: 2,
    x2: 10.99,
    y2: 5.01
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5.01,
    y1: 10.99,
    x2: 2,
    y2: 14
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2,
    y1: 2,
    x2: 5.01,
    y2: 5.01
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.99,
    y1: 10.99,
    x2: 14,
    y2: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.22,9.07V6.93h.66A.73.73,0,0,1,13.2,7a.44.44,0,0,1,.19.19.56.56,0,0,1,0,.56.47.47,0,0,1-.18.19.5.5,0,0,1,.24.19.58.58,0,0,1,.09.33.74.74,0,0,1-.08.34.5.5,0,0,1-.21.22.92.92,0,0,1-.37.06Zm.23-1.24h.38l.22,0a.3.3,0,0,0,.14-.11.33.33,0,0,0,.05-.19.42.42,0,0,0-.05-.2.23.23,0,0,0-.12-.1.79.79,0,0,0-.26,0h-.36Zm0,1h.44a.61.61,0,0,0,.22,0,.29.29,0,0,0,.15-.12.48.48,0,0,0,.05-.22.46.46,0,0,0-.05-.21.33.33,0,0,0-.14-.12.74.74,0,0,0-.26,0h-.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.32,9.07V7.18h-.58V6.93h1.4v.25h-.59V9.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew286);
export default __webpack_public_path__ + "static/media/Symbolpack_New_286.1df8d8907ae21bd98fe79a7ad690cecf.svg";
export { ForwardRef as ReactComponent };